// bluaIQ — React context carrying the Cuantificación availability decision
// (see takeoffAvailability.ts) from the project layout down to modules that
// render takeoff-linked buttons (Panel, Marcación, Presupuesto).
//
// Default is `false` (fail-closed): a module rendered outside the provider
// never shows takeoff entry points to a customer.

import { createContext, useContext } from 'react'

export const TakeoffAvailabilityContext = createContext<boolean>(false)

export function useTakeoffAvailable(): boolean {
  return useContext(TakeoffAvailabilityContext)
}
